import { iterationPerDomain } from "./genericRequest";

const domains = [
  'https://wallets.ponzilover.com',
  'https://wallets-neon.ponzilover.com',
];

export const getTransactions = async (perPage, offset, user_id) => {
  const path = `/api/transactions/${user_id}/?perPage=${perPage}&offset=${offset}`;
  return await iterationPerDomain(domains, path);
};

export const getTotalTransactions = async (user_id) => {
  const path = `/api/transactions/${user_id}/?getTotal=true`;

  const totalRows = await iterationPerDomain(domains, path);
  return totalRows[0].total || 0;
}

export const getWalletTokens = async (user_id) => {
  const path = `/api/transactions/${user_id}/?getWalletToken=true`;
  return await iterationPerDomain(domains, path);
}
